import React, { useState } from 'react';
import { PageHeader } from '../../components';
import { Button, List, ListItem, Spinner } from '@material-tailwind/react';
import { useGetUserNotifications, useMarkNotificationRead } from '../../custom-hooks/use-notifications';
import moment from 'moment';
import { DotIcon } from 'lucide-react';

moment.updateLocale('en-short', {
    relativeTime: {
        future: 'in %s',
        past: '%s',
        s: '1s',
        ss: '%ss',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1mo',
        MM: '%dmo',
        y: '1y',
        yy: '%dy'
    }
});

const Notifications = () => {

    const { data: notifications, isLoading, error } = useGetUserNotifications();
    const markNotificationReadMutation = useMarkNotificationRead();
    const [notificationIdToMarkAsRead, setNotificationIdToMarkAsRead] = useState(null);

    if (isLoading) {
        return <div className='flex justify-center items-center'>
            <Spinner />
        </div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    if (notifications && notifications.length === 0) {
        return <div>No notifications found</div>;
    }

    const handleMarkNotificationRead = async (notificationId) => {
        try {
            setNotificationIdToMarkAsRead(notificationId);
            await markNotificationReadMutation.mutateAsync({ notificationId });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className='m-4 border rounded-3xl p-4'>
            <PageHeader title='Notifications' actionType='none' />
            <div className="">
                <List>
                    {notifications.notifications.map((notification) => (
                        <ListItem ripple={false} key={notification._id} selected={!notification.readAt}>
                            <div className='flex justify-between items-center gap-2 w-full'>
                                <div>
                                    <div className='flex justify-between items-center gap-2'>
                                        <div className='text-sm font-bold flex items-center gap-1'>
                                            {!notification.readAt && (
                                                <DotIcon className="text-orange-600" />
                                            )}
                                            {notification.title}
                                        </div>
                                        <div className='text-sm text-gray-500'>
                                            {/* <Button variant='gradient' size='sm' color='orange' className='rounded-full'>
                                                <span className='text-xs font-thin capitalize'>Mark as read</span>
                                            </Button> */}
                                        </div>
                                    </div>
                                    <div className='text-sm'>
                                        {notification.message}
                                    </div>
                                    <div className='text-sm text-blue-500'>
                                        {moment(notification.createdDate).fromNow()}
                                    </div>
                                </div>
                                <div className='text-sm text-gray-500 flex flex-col items-end gap-1'>
                                    <div>
                                        {
                                            !notification.readAt && (
                                                <Button
                                                    variant='text'
                                                    size='sm'
                                                    color='orange'
                                                    className='rounded-full'
                                                    disabled={notification._id === notificationIdToMarkAsRead && markNotificationReadMutation.isLoading}
                                                    loading={notification._id === notificationIdToMarkAsRead && markNotificationReadMutation.isLoading}
                                                    onClick={() => handleMarkNotificationRead(notification._id)}>
                                                    <span className='text-xs font-bold capitalize'>Mark as read</span>
                                                </Button>
                                            )
                                        }
                                    </div>
                                    {/* <div>
                                    // TODO Develop support details nested page and then enable this button
                                        {
                                            notification.actionUrl && (
                                                <Button variant='text' size='sm' color='blue' className='rounded-full' onClick={() => window.open(notification.actionUrl, '_blank')}>
                                                    <span className='text-xs font-bold capitalize'>View</span>
                                                </Button>
                                            )
                                        }
                                    </div> */}
                                </div>
                            </div>
                        </ListItem>
                    ))}
                </List>
            </div>
        </div>
    );
};

export default Notifications;